module.exports = __webpack_public_path__ + "3e5e10ab28e5bb31960ed302995c1975.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/organizations/sectors_bg_m@3x.jpg
// module id = 668
// module chunks = 0